import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Redirect, RouteComponentProps } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import BackButton from "sweet-web/components/universal/Button/BackButton";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import SelectInput from "sweet-web/components/universal/Input/SelectInput";
import { Label, SectionTitle } from "sweet-web/components/universal/Text";
import { Section, Wrapper } from "sweet-web/components/universal/View";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import {
  ActivateVenue,
  DeactivateVenue,
  DeleteVenue
} from "sweet-web/redux/venue/actions";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const Settings: React.FC<Props> = props => {
  const { venueId } = props.match.params as { venueId: string };
  const { venue } = props;

  const back = async () => {
    props.history.push(`/listing/${venueId}/payment`);
  };

  if (!venue) {
    return <Redirect to="/listings" />;
  }

  return (
    <Wrapper>
      <Section>
        <SectionTitle style={{ margin: 0 }}>Manage Listing</SectionTitle>
        <Row>
          {!venue.active && (
            <OutlineButton
              style={{ marginRight: 10 }}
              title="Activate Listing"
              onClick={async () => {
                await props.ActivateVenue(venueId);
              }}
            />
          )}
          {venue.active && (
            <OutlineButton
              style={{ marginRight: 10 }}
              title="Deactivate Listing"
              color="gray"
              onClick={async () => {
                if (
                  window.confirm(
                    "Are you sure you want to deactivate your listing? Customers will not be able to submit inquiries or book your venue"
                  )
                ) {
                  await props.DeactivateVenue(venueId);
                }
              }}
            />
          )}
          <OutlineButton
            title="Delete Listing"
            color="gray"
            onClick={async () => {
              if (
                window.confirm(
                  "Are you sure you want to delete your listing? This is permanent and you will not be able to recover your data"
                )
              ) {
                props.history.push("/listings");
                await props.DeleteVenue(venueId);
              }
            }}
          />
        </Row>
      </Section>
      <BackButton onClick={back} />
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { venueId } = ownProps.match.params as { venueId: string };

  return {
    venue: selectors.getVenue(venueId)(state),
    loading: selectors.isUpdatingVenue(state)
  };
};
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      DeleteVenue,
      ActivateVenue,
      DeactivateVenue
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(Settings);
